import { createTermTagManager } from '../../utils/createTermTagManager';

export const withPhotoTagManager = createTermTagManager({
  jsonQueryKey: 'wp',
  label: 'С фото',
  id: 'withPhoto',
});
